import React, { useState } from "react";
import { toBinary } from "../../../../_helpers";
import axiosInstance from "../../../../axios";
import { ProgressBar } from "../../../Other/ProgressBar/ProgressBar";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const UploadCourseFile = ({
  file,
  fileID,
  storageType,
  openPreviewModal,
  removeFile,
  setFormState,
  courseId,
  isCurrentFileUploadStatus,
  isCurrentFileUpload,
}) => {
  const [progressCount, setProgressCount] = useState(0);
  const [uploader, setUploder] = useState({
    id: 0,
    isUploading: false,
    uploaded: false,
    error: false,
    message: "",
  });

  const history = useHistory();

  const getFileRequestBody = (file, courseId, storageType) => ({
    fileName: file.name.substr(0, file.name.lastIndexOf(".")),
    fileExt: file.name.substr(file.name.lastIndexOf(".") + 1),
    courseId: courseId,
    storageType: storageType,
    fileSize: file.size,
  });

  const startMultipart = async (file, courseId, storageType) => {
    setUploder({ ...uploader, isUploading: true, error: false });
    return axiosInstance
      .post("start/multipart", getFileRequestBody(file, courseId, storageType))
      .then(({ data }) => {
        if (data?.error && data?.errorCode == 9876) {
          throw new Error(data?.message);
        }
        return {
          key: data.data.Key,
          uploadId: data.data.UploadId,
          storageType: storageType,
        };
      })
      .catch((error) => {
        setUploder({
          ...uploader,
          isUploading: false,
          error: true,
          message: error?.message,
        });
      });
  };

  const configOptions = {
    headers: { "content-type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      setProgressCount((progressEvent.loaded / progressEvent.total) * 100);
    },
  };

  const getSignedURL = async ({ key, uploadId, storageType }) => {
    return axiosInstance
      .get(
        storageType === "CourseScrom"
          ? `signed-url?uploadId=${uploadId}&partNumber=1&key=${key}&storageType=${"CourseScrom"}`
          : `signed-url?uploadId=${uploadId}&partNumber=1&key=${key}`
      )
      .then(({ data }) => {
        return {
          key: key,
          uploadId: uploadId,
          signedURL: data.data,
          storageType: storageType,
        };
      })
      .catch((error) => error);
  };

  const uploadContent = async ({ key, uploadId, signedURL, storageType }) => {
    return toBinary(file).then((binaryFile) => {
      return axios
        .put(signedURL, binaryFile.blob, configOptions)
        .then((response) => ({
          key: key,
          uploadId: uploadId,
          eTag: response.headers.etag,
          storageType: storageType,
          duration: ["video/mp4", "video/mov"].includes(file.type)
            ? binaryFile.duration
            : 0,
        }));
    });
  };

  const getCompleteMultipartRequestBody = ({
    key,
    uploadId,
    eTag,
    storageType,
    duration,
  }) => ({
    uploadId: uploadId,
    uploadedParts: [
      {
        PartNumber: 1,
        ETag: `${eTag}`,
      },
    ],
    key: key,
    storageType: storageType,
    duration: Math.round(duration),
  });

  const completeMutipart = async (response) => {
    return axiosInstance
      .post("complete/multipart", getCompleteMultipartRequestBody(response))
      .then(({ data }) => {
        isCurrentFileUploadStatus(false);
        setUploder({
          ...uploader,
          isUploading: false,
          uploaded: !data.error,
          error: data.error,
          message: data.message,
          id: data.data.id,
        });
        setFormState(response);
      });
  };

  const uploadNewFile = async (file, courseId, storageType) => {
    isCurrentFileUploadStatus(true);
    startMultipart(file, courseId, storageType)
      .then(getSignedURL)
      .then(uploadContent)
      .then(completeMutipart)
      .catch((error) => {
        // setUploder(false);
        console.log(error);
      });
  };

  const removeItem = (file) => () => {
    removeFile(file.name);
  };

  const deleteFileService = async (id, courseId, storageType) => {
    return axiosInstance
      .post("delete/file", {
        courseId: courseId,
        id: id,
        storageType: storageType,
      })
      .then((response) => response);
  };

  const deleteUploadedFile = (id, name, courseId, storageType) => () => {
    deleteFileService(id, courseId, storageType).then((response) =>
      removeFile(name)
    );
  };

  const deleteExistingAndUploadNewFile = async (
    id,
    file,
    courseId,
    storageType
  ) => {
    setUploder({ ...uploader, isUploading: true, error: false });
    deleteFileService(id, courseId, storageType).then((response) => {
      if (!response.error) {
        uploadNewFile(file, courseId, storageType);
      } else {
        setUploder({
          ...uploader,
          isUploading: false,
          error: true,
          message: response.message,
        });
      }
    });
  };

  const uploadFile = (fileId, file, courseId, storageType) => {
    if (fileId > 0) {
      deleteExistingAndUploadNewFile(fileId, file, courseId, storageType);
    } else {
      uploadNewFile(file, courseId, storageType);
    }
  };
  console.log(isCurrentFileUpload);

  const handleClose = () => {
    history.push("/dashboard");
  };
  return (
    <>
      <div className="course_file-display-container">
        <div className="course_file-status-bar">
          <div className="course_fileName">
            {!uploader.isUploading ? (
              <>
                <div className="upload-bar">
                  <span
                    className={`course_file-name ${
                      file.invalid ? "file-error" : ""
                    }`}
                  >
                    {file.name.substr(0, 12)}

                    {storageType !== "CourseScrom" && (
                      <button
                        className=" btn-preview"
                        onClick={() => openPreviewModal(file)}
                      >
                        Preview
                      </button>
                    )}
                  </span>
                  {!file.invalid && (
                    <div
                      className={`${
                        uploader.uploaded
                          ? "course_file-success"
                          : "course-file-upload"
                      }`}
                      title={uploader.uploaded ? "uploaded" : "upload"}
                      style={
                        isCurrentFileUpload
                          ? { pointerEvents: "none" }
                          : { pointerEvents: "auto" }
                      }
                      onClick={() =>
                        uploadFile(fileID, file, courseId, storageType)
                      }
                    ></div>
                  )}

                  <div
                    className="course_file-remove "
                    onClick={
                      uploader.uploaded
                        ? deleteUploadedFile(
                            uploader.id,
                            file.name,
                            courseId,
                            storageType
                          )
                        : removeItem(file)
                    }
                  >
                    <div className="course_close">
                      <div>
                        <i
                          className={`icon ${
                            uploader.uploaded ? "trash" : "check"
                          }`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <ProgressBar
                barWidth={`${Math.round(progressCount)}%`}
                barMinWidth="0%"
                progressCount={progressCount}
              />
            )}
          </div>
        </div>
      </div>
      {uploader.error && (
        <div className="course_file-error-message">
          <span className="course_file-error-message">
            {uploader.message || uploader.error}
          </span>
          <div className="btn-save">
            <a className="btn-save" href="https://edusity.com/pricing">
              Upgrade Now
            </a>

            <a className="btn-save" onClick={handleClose}>
              Cancel
            </a>
          </div>
        </div>
      )}
    </>
  );
};
